export const CHANGE_LANG = 'CHANGE_LANG';


export class ChangeLanguageAction {
  readonly type = CHANGE_LANG;
  constructor(public payload: 'de' | 'en' | 'it' | 'fr') { }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/actions/lang.action.ts